import React, { useEffect } from 'react'
import GHref from 'tennders-market/common/components/element/GHref'
import CurrencyInput from 'tennders-common/form/components/new-inputs/CurrencyInput'
import TextInput from 'tennders-common/form/components/new-inputs/TextInput'
import Select from 'tennders-common/form/components/new-inputs/Select'
import GCurrency from 'tennders-market/common/components/element/GCurrency'
import PercentageInput from 'tennders-common/form/components/new-inputs/PercentageInput'
import useMultipleCostInvoiceDiscountRow from 'tennders-finance/cost-invoice/hooks/useMultipleCostInvoiceDiscountRow'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark } from '@fortawesome/free-solid-svg-icons'

export const defaultLineForm = {
  concept: 'Discount',
  amount: null,
  vatPercentage: null,
  value: null,
  applyTo: 'price',
  totalAmount: 0,
  transactionId: null,
  agreedPrice: 0
}

const applyTo = [
  { label: 'Apply To Amount on the Invoice', value: 'price' },
  { label: 'Apply To Amount on the Invoice & Extra Cost', value: 'all' }
]

const MultipleCostInvoiceDiscountRow = (props) => {
  const {
    keyIndex,
    costPrice,
    removeLine,
    onFormChange,
    index,
    initialErrors,
    defaultVat
  } = props

  const {
    errors,
    form,
    onChange
  } = useMultipleCostInvoiceDiscountRow({
    costPrice,
    onFormChange,
    initialErrors,
    index: keyIndex
  })

  useEffect(() => {
    if (defaultVat !== null) {
      onChange('vatPercentage', defaultVat)
    }
  }, [defaultVat])

  return (
    <tr>
      <td>
        <GHref
          className="cursor-pointer link-mid-gray"
          onClick={() => removeLine(keyIndex)}
        >
          <FontAwesomeIcon icon={faXmark} fontSize={20} />
        </GHref>
      </td>
      <td>
        {index + 1}
      </td>
      <td colSpan={2}>
        <Select
          placeholder="Apply to"
          value={form.applyTo}
          items={applyTo}
          onSet={(value) => onChange('applyTo', value)}
          style={{ minWidth: '100px' }}
          className="form-select smaller"
        />
      </td>
      <td>
        <TextInput
          className="form-input smaller"
          value={form.concept}
          error={errors.concept}
          onSet={(value) => onChange('concept', value)} />
      </td>
      <td>
        <PercentageInput
          className="form-input smaller"
          onSet={(value) => onChange('value', value)}
          placeholder="0%"
          value={form.value}
          error={errors.value} />
      </td>
      <td>
        <CurrencyInput
          disabled
          allowNegativeValue={false}
          className="form-input smaller disabled"
          placeholder="amount"
          value={form.amount}
          error={errors.amount} />
      </td>
      <td>
        <PercentageInput
          className="form-input smaller"
          onSet={(value) => onChange('vatPercentage', value)}
          placeholder="0%"
          value={form.vatPercentage || 0}
          error={errors.vatPercentage} />
      </td>
      <td>{form.totalAmount ? GCurrency({ value: form.totalAmount }) : '-'}</td>
    </tr>
  )
}

export default MultipleCostInvoiceDiscountRow
